import React from 'react';

import { usePhoneCall } from '../../../shared/providers/PhoneCallContext';
import type { PhoneCallState } from '../../../shared/providers/PhoneCallContext';
import type { DossierId } from '../../../resources/dossier/types';

import { InternetCallOnboarding } from './InternetCallOnboarding';
import PhoningModalComponent from './PhoningModal';
import { ActiveCallWidget } from './ActiveCallWidget/ActiveCallWidget';

function hasCallData(
    state: PhoneCallState,
): state is PhoneCallState & { dossierId: DossierId; requesterName: string } {
    return (
        (state.status === 'active' || state.status === 'ending') &&
        Boolean(state.dossierId) &&
        Boolean(state.requesterName)
    );
}

export const Phoning: React.FC = () => {
    const { state, isModalOpen, isCallActive, closeModal } = usePhoneCall();

    if (!isModalOpen) {
        return null;
    }

    const showCallWidget = isCallActive && hasCallData(state);

    /**
     * Content shown based on state:
     * - preCall, starting, error: InternetCallOnboarding (full modal)
     * - active, ending: ActiveCallWidget (call widget containing the call timer, hang up button, etc.)
     */
    const content = showCallWidget ? (
        <ActiveCallWidget requesterName={state.requesterName} dossierId={state.dossierId} />
    ) : (
        <InternetCallOnboarding />
    );

    return (
        <PhoningModalComponent
            closePhoningModal={closeModal}
            displayCloseButton={isCallActive && !state.error}
            showCallWidget={showCallWidget}
        >
            {content}
        </PhoningModalComponent>
    );
};
